// Reusable admin checkbox — a modern, accessible alternative to Switch for
// boolean/selection choices. Neutral admin palette only (never client brand).
import React from 'react';
import { View, Text, Pressable, StyleSheet } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { ADMIN_COLORS, ADMIN_FONT } from '../../config/theme/adminColors';

const AdminCheckbox = ({ value, onValueChange, label, children, disabled, style }) => (
  <Pressable
    onPress={() => !disabled && onValueChange?.(!value)}
    disabled={disabled}
    accessibilityRole="checkbox"
    accessibilityState={{ checked: !!value, disabled: !!disabled }}
    style={({ hovered }) => [
      styles.row,
      disabled && { opacity: 0.6 },
      style,
    ]}
  >
    <View style={[styles.box, value ? styles.boxChecked : styles.boxUnchecked]}>
      {value ? <Feather name="check" size={13} color="#FFFFFF" /> : null}
    </View>
    {children ? (
      children
    ) : label ? (
      <Text style={styles.label}>{label}</Text>
    ) : null}
  </Pressable>
);

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    cursor: 'pointer',
  },
  box: {
    width: 20,
    height: 20,
    borderRadius: 6,
    borderWidth: 1.5,
    alignItems: 'center',
    justifyContent: 'center',
  },
  boxUnchecked: {
    borderColor: ADMIN_COLORS.placeholder,
    backgroundColor: ADMIN_COLORS.surface,
  },
  boxChecked: {
    borderColor: ADMIN_COLORS.accent,
    backgroundColor: ADMIN_COLORS.accent,
  },
  label: {
    flex: 1,
    fontFamily: ADMIN_FONT,
    fontSize: 14,
    color: ADMIN_COLORS.label,
  },
});

export default AdminCheckbox;
